/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_TypingInputs */



/**
* | output |
* | --- |
* | "Wundo is typing" |
*
* @param {Chat_TypingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_typing = /** @type {((inputs?: Chat_TypingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_TypingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo typt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo écrit")
	return /** @type {LocalizedString} */ ("Wundo is typing")
});